<template>
  <div class="page">
  <template v-if="!currentPage">
    <AppMainPage />
  </template>
    <template v-else-if="currentPage === 'collection'">
      <AppAbout/>
    </template>
    <template v-else>
      <AppWine :wine="pagesStore.getWineByCode(currentPage)" :key="currentPage"/>
    </template>
  </div>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia';
import {usePagesStore} from "@stores/pages";
import AppMainPage from "@components/AppMainPage/index.vue";
import AppAbout from "@components/AppAbout/index.vue";
import AppWine from "@components/AppWine/index.vue";
const pagesStore = usePagesStore();
const {currentPage} = storeToRefs(pagesStore)

</script>
<style scoped lang="scss">
.page{
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
</style>